import { SectionHeader } from "../../SectionHeader";
import { ModuleGrid } from "../../../layouts/ModuleGrid";
import { useIsPortraitMobile } from "../../../hooks/useIsPortraiteMobile";
import TiltMessage from "../../../components/feedback/TiltMessage";
import { useMemo, useState } from "react";
import { MonthYearPicker } from "../../ui/month-Year-Picker";
import { format } from "date-fns";
import { EcommMarketingKpi } from "../components/ecomm-marketingkpi";
import { EcommCampaignPerformance } from "../components/ecomm-campaignPerformance";
import { TriangleAlert } from "lucide-react";


export function ECommerceMarketing() {
    const now = new Date();
    const [selectedDate, setSelectedDate] = useState<Date | undefined>(new Date(now.getFullYear(), now.getMonth()));
    const formattedDate = selectedDate ? format(selectedDate, "yyyy-MM") : "";
    const showTiltMessage = useIsPortraitMobile();
    const isCurrentMonthIncomplete = useMemo(() => {
                if (!selectedDate) return false;
                const selectedMonthStart = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 1);
                const selectedMonthEnd = new Date(selectedDate.getFullYear(), selectedDate.getMonth() + 1, 0);
                return now >= selectedMonthStart && now <= selectedMonthEnd && now.getDate() < selectedMonthEnd.getDate();
            }, [selectedDate, now]);


    return (
        <div>
            <TiltMessage show={showTiltMessage} />
            <div className={showTiltMessage ? "blur-sm pointer-events-none" : ""}>
                <SectionHeader title="E-Commerce Marketing" />
                <div className="flex flex-row items-center justify-between w-full">
                    <MonthYearPicker className="mb-2" selected={selectedDate} onChange={setSelectedDate} />
                    {isCurrentMonthIncomplete && (
                        <div className="text-sm text-yellow-200 bg-white/70 dark:bg-black/70 rounded-xl shadow-xl-soft px-3 py-2 flex flex-row items-center">
                            <TriangleAlert /> The current month is incomplete.
                        </div>
                    )}
                    </div>

                <ModuleGrid>
                    <div className="col-span-6 flex flex-col h-full">
                                <EcommMarketingKpi month={formattedDate} />
                              </div>
                    <div className="col-span-6 flex flex-col h-full">
                                <EcommCampaignPerformance month={formattedDate} />
                              </div>          
                </ModuleGrid>
            </div>
        </div>
    );
}